// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2787e5dfdf--wrapper--t4dmf","fullscreen":"_2787e5dfdf--fullscreen--LP7lX"};